import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiPostman,
  SiSlack,
  SiMacos,
  SiJirasoftware 
} from "react-icons/si";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons" title = 'MacOS'>
        <SiMacos />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title = 'VSCode'>
        <SiVisualstudiocode />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title = 'Postman'>
        <SiPostman />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title = 'Slack'>
        <SiSlack />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title = 'Jira'>
        <SiJirasoftware />
      </Col>
    </Row>
  );
}

export default Toolstack;
